module.exports = __webpack_public_path__ + "static/img/2.a85020b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/2.png
// module id = t9aI
// module chunks = 1